/* jshint esversion: 6 */
// import 'external';

import $ from 'jquery';
import throttle from 'lodash/throttle';

export default class StickyMenu {
    
    /**
     * [consoleLog description]
     *
     * @param {String} log [description]
     *
     * @return {[type]} [description]
     */
    consoleLog(log = '') {
        if (this.debug) {
            console.log('StickyMenu: ' + log);
        }
    }
    
    /**
     * [constructor description]
     *
     * @param {[type]} options [description]
     *
     * @return {[type]} [description]
     */
    constructor(options) {
        
        this.debug = false;
        
        this.defaults = {
            el: '.sticky-menu',
            toggler: '.sticky-menu-toggler',
            
            fixedClassName: 'sticky-menu-fixed',
            absoluteClassName: 'sticky-menu-absolute',
            paddingClassName: 'sticky-menu-padding',
            
            elSticky: '#header',
            elContent: '#wrapper',
            
            toggleTriggerPoint: 55,
            togglerHtml: '<div class="sticky-menu-toggler"><div class="container"><a class="sticky-menu-cart" rel="nofollow" href=""><i class="fas fa-shopping-cart"></i></a><a href="javascript:void(0)" class="sticky-menu-toggler-button"><i class="fas fa-long-arrow-alt-down"></i><i class="fas fa-long-arrow-alt-down"></i><i class="fas fa-long-arrow-alt-down"></i></a></div></div>',
        };
        
        // merge options with defaults
        this.options = $.extend({}, this.defaults, options);
        
        // merge this.option to this
        $.extend(this, this.options);
        
        this.state = 'opened';
        this.measure = true;
    }
    
    /**
     * [init description]
     *
     * @return {[type]} [description]
     */
    init() {
        if (this.check()) {
            this.prepare();
            this.run();
        }
    }
    
    /**
     * [check description]
     *
     * @return {[type]} [description]
     */
    check() {
        return $(this.el).length;
    }
    
    /**
     * [destroy description]
     *
     * @return {[type]} [description]
     */
    cleanup() {
        this.$el.removeClass('sticky-menu');
        $('.sticky-menu-toggler').remove();
    }
    
    /**
     * [prepare description]
     *
     * @return {[type]} [description]
     */
    prepare() {
        this.consoleLog('prepare [jquery: ' + $().jquery + ']');
        
        this.$window = $(window);
        this.$document = $(document);
        
        this.$el = $(this.el);
        this.$el.addClass('sticky-menu')
        this.$children = this.$el.children();
        
        this.$elSticky = $(this.elSticky);
        this.$elContent = $(this.elContent);
    }
    
    /**
     * [run description]
     *
     * @return {[type]} [description]
     */
    run() {
        this.consoleLog('run [jquery: ' + $().jquery + ']');
        
        this.addAbsoluteAndPadding();
        // this.matchPadding()
        this.addToggler();
        this.addCheckOnScroll();
        this.scrollCheck();
    }
    
    /**
     * [onWindowResize description]
     *
     * @return {[type]} [description]
     */
    onWindowResize() {
        if (!this.check()) {
            return;
        }
        window.scrollTo(0, 0);
    }
    
    /**
     * [addAbsoluteAndPadding description]
     */
    addAbsoluteAndPadding() {
        this.$elSticky.addClass(this.absoluteClassName);
        this.$elContent.addClass(this.paddingClassName);
    }
    
    // matchPadding() {
    //     this.$elContent.css('padding-top', this.$elSticky.height() + 'px');
    // }
    
    /**
     * [addToggler description]
     */
    addToggler() {
        this.$el.prepend(this.togglerHtml);
        this.$toggler = $(this.toggler);
        this.$togglerButton = this.$toggler.find('.sticky-menu-toggler-button');
        if (this.$document.scrollTop() <= this.toggleTriggerPoint) {
            this.$toggler.hide();
        }
        
        // manual open
        this.$togglerButton.on('click', () => {
            this.menuOpen(250);
        });
        
        // manual close
        this.$elContent.on('click', () => {
            // close menu on click on content
            if (this.$document.scrollTop() > this.toggleTriggerPoint && this.state === 'opened') {
                this.menuClose(250);
            }
        });
    }
    
    /**
     * [addCheckOnScroll description]
     */
    addCheckOnScroll() {
        
        this.debouncedScroll = throttle(() => {
            this.consoleLog('scroll actions');
            
            this.scrollCheck();
            // scrollTop = this.$document.scrollTop();
            // this.actionOnScroll();
            
        }, 100, {
            leading: false,
            trailing: true,
        });
        
        this.$document.on('scroll', () => {
            this.debouncedScroll();
        });        
    }
    
    /**
     * [scrollCheck description]
     *
     * @return {[type]} [description]
     */
    scrollCheck() {
        this.scrollTop = this.$document.scrollTop();
        this.actionOnScroll();
        this.consoleLog('scroll check');
    }
    
    /**
     * [actionOnScroll description]
     *
     * @return {[type]} [description]
     */
    actionOnScroll() {
        if (!this.measure) {
            return;
        }
        
        // this.backgroundOfFixedElement();
        // this.checkIfStickyIsFixededOrAbsolute();
            
        // actions
        if (this.scrollTop > this.toggleTriggerPoint) {
            // setTimeout(
                // () => {
                    this.menuClose();
                    // this.backgroundOfFixedElement();
                    // this.checkIfStickyIsFixededOrAbsolute();
                // },
                // 1
            // );
        } else {
            // setTimeout(
                // () => {
                    this.menuOpen();
                    // this.backgroundOfFixedElement();
                    // this.checkIfStickyIsFixededOrAbsolute();
                // },
                // 1
            // );
        }
    }
    
    /**
     * [backgroundOfFixedElement description]
     *
     * @return {[type]} [description]
     */
    backgroundOfFixedElement() {
        // background color of fixed menu
        if (this.scrollTop > this.toggleTriggerPoint) {
            if (!this.$elSticky.hasClass('sticky-menu-opaque')) {
                this.$elSticky.addClass('sticky-menu-opaque');
            }
        } else {
            if (this.$elSticky.hasClass('sticky-menu-opaque')) {
                this.$elSticky.removeClass('sticky-menu-opaque');
            }
        }
    }
    
    /**
     * [checkIfStickyIsFixededOrAbsolute description]
     *
     * @return {[type]} [description]
     */
    checkIfStickyIsFixededOrAbsolute() {
        if (this.scrollTop > this.toggleTriggerPoint) {
            if (this.$elSticky.hasClass(this.absoluteClassName)) {
                this.$elSticky.removeClass(this.absoluteClassName);
                this.$elSticky.addClass(this.fixedClassName);
                // this.$elContent.addClass(this.paddingClassName);
            }
        } else {
            if (this.$elSticky.hasClass(this.fixedClassName)) {
                this.$elSticky.removeClass(this.fixedClassName);
                this.$elSticky.addClass(this.absoluteClassName);
                // this.$elContent.removeClass(this.paddingClassName);
            }
        }
    }
    
    /**
     * [menuClose description]
     *
     * @return {[type]} [description]
     */
    menuClose(speed = 10) {
        if (this.state === 'closed') {
            this.consoleLog('menu is closed');
            this.backgroundOfFixedElement();
            this.checkIfStickyIsFixededOrAbsolute();
            return;
        }
        this.consoleLog('closing');
        this.measure = false;
        this.$children.slideUp(speed, () => {
            this.state = 'closed';
            this.$toggler.show();
            this.measure = true;
            
            this.backgroundOfFixedElement();
            this.checkIfStickyIsFixededOrAbsolute();
            
            // additional check if it really should be closed
            if (this.$document.scrollTop() <= this.toggleTriggerPoint && this.state === 'closed') {
                this.menuOpen();
            }
        });
    }
    
    /**
     * [menuOpen description]
     *
     * @return {[type]} [description]
     */
    menuOpen(speed = 10) {
        if (this.state === 'opened') {
            this.consoleLog('menu is opened');
            this.backgroundOfFixedElement();
            this.checkIfStickyIsFixededOrAbsolute();
            return;
        }
        this.consoleLog('opening');
        this.measure = false;
        this.$children.slideDown(speed, () => {
            this.state = 'opened';
            this.$toggler.hide();
            this.measure = true;
            
            this.backgroundOfFixedElement();
            this.checkIfStickyIsFixededOrAbsolute();
            
            // this.matchPadding();
        });
    }
}



// WEBPACK FOOTER //
// ./modules/sticky-menu/js/sticky-menu.js